// @ts-nocheck
const postalCodeRegex = /^(\d{5}(-\d{4})?|[A-Z]\d[A-Z] {1}?\d[A-Z]\d)$/;

export const isValidPostalCode = (value: string) => postalCodeRegex.test(value);
